// extracted by mini-css-extract-plugin
export var grid = "_26-0";
export var span1 = "_26-2";
export var span10 = "_26-b";
export var span10L = "_26-z";
export var span10M = "_26-n";
export var span10Xl = "_26-1b";
export var span11 = "_26-c";
export var span11L = "_26-10";
export var span11M = "_26-o";
export var span11Xl = "_26-1c";
export var span12 = "_26-d";
export var span12L = "_26-11";
export var span12M = "_26-p";
export var span12Xl = "_26-1d";
export var span1L = "_26-q";
export var span1M = "_26-e";
export var span1Xl = "_26-12";
export var span2 = "_26-3";
export var span2L = "_26-r";
export var span2M = "_26-f";
export var span2Xl = "_26-13";
export var span3 = "_26-4";
export var span3L = "_26-s";
export var span3M = "_26-g";
export var span3Xl = "_26-14";
export var span4 = "_26-5";
export var span4L = "_26-t";
export var span4M = "_26-h";
export var span4Xl = "_26-15";
export var span5 = "_26-6";
export var span5L = "_26-u";
export var span5M = "_26-i";
export var span5Xl = "_26-16";
export var span6 = "_26-7";
export var span6L = "_26-v";
export var span6M = "_26-j";
export var span6Xl = "_26-17";
export var span7 = "_26-8";
export var span7L = "_26-w";
export var span7M = "_26-k";
export var span7Xl = "_26-18";
export var span8 = "_26-9";
export var span8L = "_26-x";
export var span8M = "_26-l";
export var span8Xl = "_26-19";
export var span9 = "_26-a";
export var span9L = "_26-y";
export var span9M = "_26-m";
export var span9Xl = "_26-1a";
export var stretch = "_26-1";